import Logobanner from "../../../assets/img/projects/Maison_Marline/LogoBanner.svg";

function App() {
  return (
    <div className="MM-banner">
      {" "}
      <img src={Logobanner} alt="Logo Banner" />
    </div>
  );
}

export default App;
